import {API} from "../api";
import type {GridBackground} from "./default-resources";

/** Same authoritative query as ordinary Coverbaker; product belongs in v3's key. */
export function gridBackgroundQueryOptions(channel: string, type: string, product: string) {
  return {queryKey: ["v3-backgrounds", channel, type, product] as const, staleTime: 5 * 60_000,
    queryFn: async (): Promise<{backgrounds: GridBackground[]}> => {
      const response = await API.fetchBackgroundsCatalog(channel, type, product);
      if (!Array.isArray(response?.backgrounds)) throw new Error("Invalid background catalog: backgrounds missing");
      return response;
    }};
}
